<template>
  <div class="page-wrapper">

    <div v-if="showShuffleModal" class="modal-backdrop-shuffle">
      <div class="modal-shuffle">
        <h2>{{shuffleText}}</h2>
      </div>
    </div> 

    <HeaderMain></HeaderMain>
    <HeaderBottomMain></HeaderBottomMain>
    
    <div class="content-wrapper">
      <!--  <CommercialLeftSide></CommercialLeftSide> -->

      <main class="main-content">
        <div class="info-card">
          <h2 class="card-title">Reveal the clues and name the card 🎯</h2>

          <div class="info-list">
            <div
              v-for="(item, index) in items"
              :key="index"
              class="info-row"
            >
              <div class="info-key">{{ item.key }}</div>

              <button class="eye-button" @click="toggleVisibility(index)">
                <svg v-if="!item.visible" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="eye-icon">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223C5.78 6.343 8.732 4.5 12 4.5c3.268 0 6.22 1.843 8.02 3.723a9.46 9.46 0 0 1 1.98 3.777 9.46 9.46 0 0 1-1.98 3.777C18.22 17.657 15.268 19.5 12 19.5c-3.268 0-6.22-1.843-8.02-3.723A9.46 9.46 0 0 1 2 12a9.46 9.46 0 0 1 1.98-3.777z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="eye-icon">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223C5.78 6.343 8.732 4.5 12 4.5c3.268 0 6.22 1.843 8.02 3.723a9.46 9.46 0 0 1 1.98 3.777 9.46 9.46 0 0 1-1.98 3.777C18.22 17.657 15.268 19.5 12 19.5c-3.268 0-6.22-1.843-8.02-3.723A9.46 9.46 0 0 1 2 12a9.46 9.46 0 0 1 1.98-3.777zM3 3l18 18"/>
                </svg>
              </button>

              <div class="info-value">
                <span v-if="!item.visible" class="hidden-value">* * * * * * * *</span>
                <span v-if="item.visible && item.key == 'Mana cost'">
                  <img
                    v-for="(url, i) in parseManaSymbols(card.mana_cost)"
                    :key="i"
                    :src="url"
                    alt="Mana symbol"
                    width="18"
                    height="18"
                  />
                </span>
                <span v-if="item.visible && item.key != 'Mana cost'">{{ item.value }}</span>          
              </div>
            </div>
          </div>

            <div class="answer-section">
              <input
                type="text"
                v-model="searchTerm"
                placeholder="Type at least 3 characters..."
                class="answer-input"
                @input="onInput"
                @keydown.down.prevent="moveDown"
                @keydown.up.prevent="moveUp"
                @keydown.enter.prevent="selectHighlighted"
                @blur="dropdownOpen = false"
                @focus="dropdownOpen = true"
              />

              <ul v-if="dropdownOpen && options.length" class="dropdown">
                <li
                  v-for="card in options"
                  :key="card"
                  @mousedown.prevent="selectCard(card)"
                >
                  {{ capitalizeFirst(card) }}
                </li>
              </ul>

              <div class="status-messages">
                <div v-if="loading">Loading...</div>
                <div v-if="error">Please, type it again</div>
              </div>

              <button 
                @click="sendAnswer" 
                :disabled="!isCheck" 
                :class="isCheck ? 'answer-button-enable' : 'answer-button-disable'" 
                :title="!isCheck ? 'Select a card in the field next to it' : ''"   
              >Check</button>
            </div>

            <div v-if="showModal" class="modal-backdrop">
              <div class="modal">
                <h2>{{modalTitle}}</h2>
                <img v-if="modalImage" :src="modalImage" alt="Carta" class="card-image"/>
                <div class="modal-buttons">
                  <button v-for="(btn, i) in modalButtons" :key="i" @click="btn.action">
                    {{ btn.label }}
                  </button>
                </div>
              </div>
            </div>

        </div>
      </main>

      <!-- <CommercialRightSide></CommercialRightSide> -->
    </div> 

    <FooterMain></FooterMain>
    <FooterDisclaimer></FooterDisclaimer>
    
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'

import HeaderMain from './components/HeaderMain.vue'
import HeaderBottomMain from './components/HeaderBottomMain.vue'
import FooterMain from './components/FooterMain.vue'
import FooterDisclaimer from './components/FooterDisclaimer.vue'
import ids from '@/assets/scryfall_id.js'

const scyfall_url = "https://api.scryfall.com"
const winText = "You nailed it! ✅"
const revealText = "There it is ⬇️"
const loseText = "Ouch! Missed it ❌"
const shuffleText = "Hang on, shuffling the cards 🔄"

const items = ref([])
const searchTerm = ref('')
const options = ref([])
const selectedCard = ref(null)
const dropdownOpen = ref(false)
const highlightedIndex = ref(-1)
const showModal = ref(false)
const modalTitle = ref('')
const modalImage = ref('')
const modalButtons = ref([])
const error = ref(null)
const loading = ref(false)
const showShuffleModal = ref(true)

const isCheck = computed(() => { return searchTerm.value.length >= 3 && selectedCard.value })

onMounted(() => {
  setTimeout(() => {
    showShuffleModal.value = false
  }, 2200)
})

let card = null
onMounted(async () => {
  try {
    const res = await fetch(`${scyfall_url}/cards/${getRandomId()}`)
    const data = await res.json()
    card = data

    const [type, subtype] = card.type_line.split('—')

    items.value = [
      { key: "Mana cost", value: card.mana_cost, visible: false },
      { key: "Rarity", value: capitalizeFirst(card.rarity), visible: false },
      { key: "Type", value: type, visible: false },
      { key: "SubType", value: subtype ?? "-", visible: false },
      { key: "Power", value: card.power ?? "-", visible: false },
      { key: "Toughness", value: card.toughness ?? "-", visible: false },
      { key: "Legal in Pauper", value: isLegal(card.legalities?.pauper), visible: false },
      { key: "Legal in Standard", value: isLegal(card.legalities?.standard), visible: false },
      { key: "Legal in Premodern", value: isLegal(card.legalities?.premodern), visible: false },
      { key: "Part of the text", value: "..." + card.oracle_text?.substring(6, 40), visible: false }
    ]
  } catch {
    window.location.reload()
  }
})

let debounceTimeout
const onInput = () => {
  clearTimeout(debounceTimeout)
  debounceTimeout = setTimeout(() => {
    if (searchTerm.value.length >= 3) {
      fetchCards(searchTerm.value)
    } else {
      options.value = []
      dropdownOpen.value = false
    }
  }, 500)
}

async function fetchCards(term) {
  loading.value = true
  error.value = null
  try {
    const res = await fetch(`${scyfall_url}/cards/autocomplete?q=${encodeURIComponent(term)}`)
    const data = await res.json()
    options.value = (data.data || []).slice(0, 5)

    dropdownOpen.value = options.value.length > 0
    highlightedIndex.value = -1
  } catch (err) {
    error.value = 'Please, type it again'
    options.value = []
  } finally {
    loading.value = false
  }
}

async function sendAnswer() {
  if (!selectedCard.value) return alert('Select a card name!')
  
  if (searchTerm.value.toLowerCase() === card.name.toLowerCase()) {
    try {
      const res = await fetch(`${scyfall_url}/cards/${card.id}`)
      const data = await res.json()
      document.documentElement.style.setProperty('--color-modal-border', '#6fa57b')
      modalTitle.value = winText
      modalImage.value = data.image_uris?.normal || ''
      modalButtons.value = [
        { label: 'Play again', action: resetGame }
      ]
    } catch (err) {
      document.documentElement.style.setProperty('--color-modal-border', '#6fa57b')
      modalTitle.value = winText
      modalImage.value = ''
      modalButtons.value = [
        { label: 'Play again', action: resetGame }
      ]
    }
  } else {
    modalTitle.value = loseText
    modalImage.value = ''
    modalButtons.value = [
      { label: 'Try again', action: tryAgain },
      { label: 'Show card', action: showCorrectCard }
    ]
  }
  showModal.value = true
}

async function showCorrectCard() {
  try {
    const res = await fetch(`${scyfall_url}/cards/${card.id}`)
    const data = await res.json()
    document.documentElement.style.setProperty('--color-modal-border', '#ac3b3b')
    modalTitle.value = revealText
    modalImage.value = data.image_uris?.normal || ''
    modalButtons.value = [
      { label: 'Try again', action: resetGame }
    ]
  } catch {
    modalTitle.value = 'Error'
    modalImage.value = ''
    modalButtons.value = [
      { label: 'Try again', action: resetGame }
    ]
  }
}

function getRandomId() {
  const random = crypto.getRandomValues(new Uint32Array(1))[0] / 2**32
  const index = Math.floor(random * ids.length)
  return ids[index]
}

function isLegal(legality) {
  return legality == 'legal' ? "Yes" : "No"
}

function toggleVisibility(index) {
  if(items.value[index].visible == true) return

  items.value[index].visible = true
}

function parseManaSymbols(manaCost) {
  if (!manaCost) return []

  const symbols = manaCost.match(/{[^}]+}/g) || []
  return symbols.map(sym => {
    const clean = sym.replace(/[{}]/g, '').toUpperCase().replace('/', '')
    return `https://svgs.scryfall.io/card-symbols/${clean}.svg`
  })
}

function selectCard(card) {
  selectedCard.value = card
  searchTerm.value = card
  dropdownOpen.value = false
}

function resetGame() {
  searchTerm.value = ''
  selectedCard.value = null
  options.value = []
  showModal.value = false

  window.location.reload()
}

function tryAgain() {
  searchTerm.value = ''
  dropdownOpen.value = true
  showModal.value = false
}

function capitalizeFirst(str) {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

function moveDown() {
  if (highlightedIndex.value < options.value.length - 1) highlightedIndex.value++
}
function moveUp() {
  if (highlightedIndex.value > 0) highlightedIndex.value--
}
function selectHighlighted() {
  if (highlightedIndex.value >= 0) {
    selectCard(options.value[highlightedIndex.value])
  }
}
</script>

<style scoped>

.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  flex: 1;
  display: flex;
  gap: 16px;
  padding: 24px 36px;
  justify-content: center;
  align-items: flex-start;
}

.main-content {
  flex: 1;
  display: flex;
  justify-content: center;
}

.info-card {
  width: 100%;
  max-width: 600px;
  border-radius: 16px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  background-color: var(--color-card);
  box-shadow: var(--shadow-box-default);
}

.card-title {
  font-size: 26px;
  text-align: center;
  color: var(--color-text-title);
  text-shadow: var(--shadow-text-default);
}

.info-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-key {
  flex: 1;
  text-align: right;
  font-size: 16px;
  color: var(--color-text-info-value);
}

.info-value {
  flex: 1;
  text-align: left;
  font-size: 16px;
  color: var(--color-text-info-value);
}

.hidden-value {
  color: var(--color-text-info-value);
}

.eye-button {
  background: none;
  border: none;
  cursor: pointer;
  margin: 0 20px;
}

.eye-icon {
  width: 24px;
  height: 24px;
  color: var(--color-eye);
}

.answer-section {
  display: flex;
  gap: 24px;
  margin: 12px 0;
  position: relative;
}

.answer-input {
  flex: 1;
  padding: 12px 14px;
  border-radius: 12px;
  border: none;
  outline: none;
  font-size: 14px;
  transition: background 0.3s, box-shadow 0.3s;
  background-color: var(--color-answer-input);
  color: var(--color-answer-text);
}

.answer-input::placeholder {
  color: var(--color-answer-placeholder);
}

.answer-input:focus {
  background-color: var(--color-answer-input-focus);
  box-shadow: var(--shadow-input-focus)
}

.answer-button-enable {
  padding: 12px 20px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s, transform 0.1s;
  background-color: var(--color-buttom);
  color: var(--color-text-buttom);
}

.answer-button-enable:hover {
  transform: scale(1.03);
  background-color: var(--color-buttom-hover);
  color: var(--color-main-info);
  box-shadow: var(--shadow-box-default);
}

.answer-button-disable {
  padding: 12px 20px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 16px;
  background-color: #c2a06d2c;
  color: var(--color-text-buttom);
}

.dropdown {
  position: absolute;
  top: 100%;
  width: 100%;
  max-height: 220px;
  overflow-y: auto;
  margin-top: 6px;
  border-radius: 12px;
  list-style: none;
  z-index: 1000;
  border: 1px solid #000000;
  background-color: var(--color-answer-input-focus);
}

.dropdown li {
  padding: 8px 12px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  color: var(--color-answer-text);
}

.dropdown li.highlighted {
  background-color: #6e580c;
  color: #1C1B18;
}

.status-messages {
  margin-top: 6px;
  min-height: 20px;
  position: absolute;
  top: 100%;
  color: var(--color-text-info-value);
}

.modal {
  padding:38px;
  border-radius:12px;
  text-align:center;
  max-width:450px;
  color: var(--color-modal-text);
  background-color:var(--color-modal);
  border: 4px solid var(--color-modal-border);
}

.modal-backdrop {
  position: fixed; top:0; left:0; right:0; bottom:0;
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:2000;
  background-color: var(--color-backdrop-modal);
}

.card-image {
  max-width: 100%;
  margin: 16px 0;
  border-radius: 20px;
  background-color:#000000;
}

.modal-buttons button {
  margin:24px;
  padding: 14px 28px;
  border-radius: 10px;
  border: none;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s, transform 0.1s;
  background-color: var(--color-buttom);
  color: var(--color-text-buttom);
}

.modal-buttons button:hover {
  transform: scale(1.03);
  background-color: var(--color-buttom-hover);
  color: var(--color-main-info);
}

.modal-shuffle {
  position: fixed;
  top: 18%;
  left: 50%;
  transform: translate(-50%, -50%);

  padding:32px 52px;
  border-radius:12px;
  text-align:center;
  font-size: 18px;
  color: var(--color-modal-text);
  background-color:var(--color-modal);
  border: 3px solid var(--color-main-info);
}

.modal-backdrop-shuffle {
  position: fixed; top:0; left:0; right:0; bottom:0;
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:2000;
  background-color: var(--color-backdrop-modal);
}

</style>
